__turbopack_context__.v({
  "blockquote": "LegalDocument-module__v7TW7a__blockquote",
  "body": "LegalDocument-module__v7TW7a__body",
  "callout": "LegalDocument-module__v7TW7a__callout",
  "details": "LegalDocument-module__v7TW7a__details",
  "figure": "LegalDocument-module__v7TW7a__figure",
  "h1": "LegalDocument-module__v7TW7a__h1",
  "h2": "LegalDocument-module__v7TW7a__h2",
  "h3": "LegalDocument-module__v7TW7a__h3",
  "hr": "LegalDocument-module__v7TW7a__hr",
  "li": "LegalDocument-module__v7TW7a__li",
  "metaLabel": "LegalDocument-module__v7TW7a__metaLabel",
  "metaRow": "LegalDocument-module__v7TW7a__metaRow",
  "orderedList": "LegalDocument-module__v7TW7a__orderedList",
  "p": "LegalDocument-module__v7TW7a__p",
  "styledImage": "LegalDocument-module__v7TW7a__styledImage",
  "styledImageFramed": "LegalDocument-module__v7TW7a__styledImageFramed",
  "summary": "LegalDocument-module__v7TW7a__summary",
  "table": "LegalDocument-module__v7TW7a__table",
  "tableWrapper": "LegalDocument-module__v7TW7a__tableWrapper",
  "td": "LegalDocument-module__v7TW7a__td",
  "th": "LegalDocument-module__v7TW7a__th",
  "toc": "LegalDocument-module__v7TW7a__toc",
  "tocItem": "LegalDocument-module__v7TW7a__tocItem",
  "tocList": "LegalDocument-module__v7TW7a__tocList",
  "tocSummary": "LegalDocument-module__v7TW7a__tocSummary",
  "toggleBody": "LegalDocument-module__v7TW7a__toggleBody",
  "toggleIcon": "LegalDocument-module__v7TW7a__toggleIcon",
});
